import { Box, Grid, Typography } from "@mui/material";
import {
    AutocompleteInput,
    email,
    TextInput,
    useLocaleState,
    useTranslate,
} from "react-admin";
import { RaSelectInput } from "shared/src/components/inputs/Ra/RaSelectInput";
import { countries } from "shared/src/constants/countries";

export const AddressFormInput = () => {
    const translate = useTranslate();
    const [locale] = useLocaleState();

    return (
        <Box
            sx={{
                border: "1px solid gray",
                borderRadius: 2,
                padding: 2,
                width: "100%",
            }}
        >
            <Typography variant="body1" gutterBottom>
                {translate("equip.addressForm")}
            </Typography>
            <Grid container spacing={2} rowSpacing={0}>
                <Grid size={{ md: 6, xs: 12 }}>
                    <Box>
                        <TextInput
                            label="equip.firstname"
                            title={translate("equip.firstname")}
                            source="address.firstname"
                        />
                        <TextInput
                            label="equip.lastname"
                            title={translate("equip.lastname")}
                            source="address.lastname"
                        />
                        <RaSelectInput
                            source="address.gender"
                            label="equip.gender"
                            title="equip.gender"
                            choices={[
                                { id: "male", name: "equip.male" },
                                {
                                    id: "female",
                                    name: "equip.female",
                                },
                            ]}
                        />
                        <TextInput
                            label={translate("equip.address", {
                                addressNumber: "1",
                            })}
                            title={translate("equip.address", {
                                addressNumber: "1",
                            })}
                            source="address.address1"
                        />
                        <TextInput
                            label={translate("equip.address", {
                                addressNumber: "2",
                            })}
                            title={translate("equip.address", {
                                addressNumber: "2",
                            })}
                            source="address.address2"
                        />
                        <TextInput
                            label={translate("equip.address", {
                                addressNumber: "3",
                            })}
                            title={translate("equip.address", {
                                addressNumber: "3",
                            })}
                            source="address.address3"
                        />
                    </Box>
                </Grid>
                <Grid size={{ md: 6, xs: 12 }}>
                    <Box>
                        <AutocompleteInput
                            source="address.country"
                            choices={countries}
                            optionText={`name.${locale}`}
                            defaultValue={"DE"}
                        />
                        <TextInput
                            label="equip.zip"
                            title={translate("equip.zip")}
                            source="address.zip"
                        />
                        <TextInput
                            label="equip.city"
                            title={translate("equip.city")}
                            source="address.city"
                        />
                        <TextInput
                            label="equip.email"
                            title={translate("equip.email")}
                            source="address.email"
                            validate={email()}
                        />
                        <TextInput
                            label="equip.phone"
                            title={translate("equip.phone")}
                            source="address.phone"
                        />
                        <TextInput
                            label="equip.fax"
                            title={translate("equip.fax")}
                            source="address.fax"
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};
